export const normalizePlate = (value = "") => String(value).toUpperCase().replace(/[\s-]/g, "");

export function cycleResult(value) {
  let response = value;
  if (typeof value === "string") {
    try {
      response = JSON.parse(value);
    } catch {
      return { code: null, severity: "error", label: "Respuesta no válida", message: value };
    }
  }
  if (!response || typeof response !== "object") {
    return {
      code: null,
      severity: "info",
      label: "Sin respuesta",
      message: "Sin respuesta registrada",
    };
  }
  const rawCode = response.Code ?? response.code;
  const rawStatus = response.Status ?? response.status;
  const numeric = rawCode ?? rawStatus;
  const parsedCode =
    numeric === undefined || numeric === null || numeric === "" ? null : Number(numeric);
  const code = Number.isFinite(parsedCode) ? parsedCode : null;
  const message = String(response.Message ?? response.message ?? response.detail ?? "");
  const labels = {
    300: "Estado no permitido",
    301: "Horas inconsistentes",
    302: "Operación rechazada",
    304: "Sin información del reader",
    400: /tid/i.test(message) ? "No se encuentra TID" : "Datos no válidos",
  };
  if (code !== null && code >= 200 && code < 300) {
    return { code, severity: "success", label: "Operación aceptada", message };
  }
  return {
    code: Number.isFinite(code) ? code : null,
    severity:
      code !== null && code >= 300 && code < 500
        ? "warning"
        : message || code !== null
        ? "error"
        : "info",
    label:
      labels[code] ||
      (code !== null ? `Error ${code}` : message ? "Error técnico" : "Sin respuesta"),
    message: message || "Sin respuesta registrada",
  };
}

export function bogotaNow(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const get = (type) => parts.find((part) => part.type === type).value;
  return {
    date: `${get("year")}-${get("month")}-${get("day")}`,
    time: `${get("hour")}:${get("minute")}`,
  };
}

export function entryToISO(date, time) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) {
    throw new Error("Fecha u hora inválida");
  }
  const instant = new Date(`${date}T${time}:00.000-05:00`);
  if (isNaN(instant.getTime()) || bogotaNow(instant).date !== date)
    throw new Error("Fecha inválida");
  return `${date}T${time}:00.000-05:00`;
}

export function cycleDate(value) {
  if (!value) return "Sin registro";
  const date = new Date(value);
  return isNaN(date.getTime())
    ? "Fecha inválida"
    : new Intl.DateTimeFormat("es-CO", {
        timeZone: "America/Bogota",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23",
      }).format(date);
}

export function cycleDay(value) {
  const date = value ? new Date(value) : null;
  return date && !isNaN(date.getTime()) ? bogotaNow(date).date : "";
}

// Compatibility for get-cycles: UTC createdAt values arrive five hours ahead.
// Only use for server registration timestamps, never entry/exit or the local clock.
export function cycleCreatedAt(value) {
  if (typeof value !== "string" || !/(Z|[+]00:?00)$/i.test(value)) return cycleDate(value);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Fecha inválida";
  return cycleDate(new Date(date.getTime() - 5 * 60 * 60 * 1000));
}
